import { store } from "./store";

export const getAuthState = () => store.getState()?.login || {};

export const getAuthUserPayload = () => getAuthState().user || null;

export const getAuthUser = () => {
  const user = getAuthUserPayload();
  if (user && user.user instanceof Array && user.user[0]) {
    return user.user[0];
  }

  if (user && !(user.user instanceof Array)) {
    return user.user;
  }

  return null;
};

export const getOrgUserList = () => {
  const orgUserList = getAuthState().orgUserList;
  return Array.isArray(orgUserList) ? orgUserList : [];
};
